import React, { useState, useEffect } from "react";
import styles from "./Hero.module.css";
import { useNavigate } from "react-router-dom";

export const Hero = ({ scrollToSection, joinWaitlistRef }) => {
  const navigate = useNavigate();

  const words = [
    { text: "complex.", color: "#302571" },
    { text: "full of risk.", color: "#FFD700" },
    { text: "volatile.", color: "#007A78" },
    { text: "unpredictable.", color: "#FF7300" },
    { text: "changing every second.", color: "#008CFF" },
  ];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-gradient-to-tr to-[#413072] from-[#08080B] max-lg:h-[100dvh] lg:max-h-[525px] [@media(min-width:1100px)]:!max-h-[650px] overflow-y-hidden">
      <div
        className={
          "w-full max-xl:h-full max-w-[1320px] mx-auto grid lg:grid-cols-2 items-center justify-center gap-0 lg:px-5 max-lg:pt-20"
        }
      >
        {/* on lft */}
        <div className="w-full mt-[-5px] [@media(min-width:1100px)]:!mt-[0px] xl:!mt-[-20px] hidden lg:block pointer-events-none">
          {/* <img src="/images/xicon.svg" alt="" className="w-full" /> */}
          <img src="/images/xicon.svg" alt="" className="w-full" />
        </div>
        {/* on right */}
        <div className="flex flex-col items-start pl-10 lg:pl-[5em] pr-5">
          <h1 className="text-[48px] font-bold text-white leading-[1.1] text-left">
            Simplifying Trades, Amplifying Returns
          </h1>
          <p className="text-base text-white/70 font-normal">
            Unlock the power of automated crypto trading with tailored
            strategies. Maximize opportunities, profits, and growth — backed by
            education and a supportive community.
          </p>
          <button
            onClick={() => navigate("/signup")}
            type="submit"
            className="w-fit rounded-full relative overflow-hidden !py-3 !font-bold !text-lg bg-teal-700 hover:bg-teal-800 mt-4 px-8"
          >
            Start Your Free Trial
          </button>
        </div>
      </div>
    </section>
    // <section className={styles.hero}>
    //   <div className={styles.content}>
    //     <div className={styles.sectionText}>
    //       <h1 className={styles.title}>
    //         Crypto market is <br className={styles.mobileBr}/><span style={{ color: words[currentWordIndex].color}}>{words[currentWordIndex].text}</span>
    //       </h1>
    //       <h1 className={styles.title2}>But trading can be simple—
    //       seize opportunities effortlessly.</h1>
    //     </div>

    //     <div className={styles.buttonContainer}>
    //       <button className={styles.heroButton} onClick={() => scrollToSection(joinWaitlistRef)}>Get early access</button>
    //       <p className={styles.subText}>and unlock Your 3-Month Free Trial!</p>
    //     </div>
    //   </div>

    //   <div className={styles.imageSection}>
    //     <img
    //       src="/images/Desktop.png"
    //       alt="Trading platform interface"
    //       className={styles.mainImage}
    //     />
    //     <div className={styles.phonePreview}>
    //       <img
    //         src="/images/Phone.png"
    //         alt="Mobile app preview"
    //         className={styles.phoneImage}
    //       />
    //       <div className={styles.dynamicIsland} />
    //     </div>
    //   </div>
    // </section>
  );
};
